"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultKey = ['latestActivity'];
const keys = {
    default: defaultKey,
    latestActivity: (id) => ['objective', id, ...defaultKey]
};
exports.default = keys;
